import { notificationConstants } from '../constants/notification.constants';

export function notification(state = {}, action) {
  switch (action.type) {
    case notificationConstants.CREATE_REQUEST:
    case notificationConstants.UPDATE_REQUEST:
    case notificationConstants.FETCH_REQUEST:    
    case notificationConstants.GET_REQUEST:
    case notificationConstants.REMOVE_REQUEST:
    case notificationConstants.FETCH_TYPES_REQUEST:
    case notificationConstants.FETCH_NOTIFICATIONS_REQUEST:
      return {
        ...state,
        loading: true
      };    
    case notificationConstants.CREATE_SUCCESS:
    case notificationConstants.GET_SUCCESS:
    case notificationConstants.UPDATE_SUCCESS:
    return{
      ...state,
      notificationConfig: action.notificationConfig,
      loading: false
    }        
    case notificationConstants.FETCH_SUCCESS:      
      return {
        ...state,
        ...action.notificationConfigs,
        loading: false
      };
    case notificationConstants.FETCH_TYPES_SUCCESS:      
      return {
        ...state,
        notificationTypes: action.notificationTypes,
        loading: false
      };
      case notificationConstants.FETCH_NOTIFICATIONS_SUCCESS:      
      return {
        ...state,
        notifications: action.notifications,
        loading: false
      };
    case notificationConstants.CREATE_FAILURE:
    case notificationConstants.FETCH_FAILURE:
    case notificationConstants.FETCH_TYPES_FAILURE:
    case notificationConstants.FETCH_NOTIFICATIONS_FAILURE:
    case notificationConstants.GET_FAILURE:
    case notificationConstants.REMOVE_FAILURE:
    case notificationConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error
      };   
    default:
      return state
  }
}
